<template>
	<CreationWizardListItemRow class="app-row" :title="app.service_name" :icon="app.service_slug" />
</template>

<script>
import CreationWizardListItemRow from '../common/CreationWizardListItemRow.vue';
export default {
	name: 'AppRow',
	props: { app: { type: Object } },
	components: { CreationWizardListItemRow },
};
</script>

<style lang="scss" scoped></style>
